
import { Vue } from "vue-class-component";
import moment from "moment";
import { set, get, keys, del, Store } from "idb-keyval";
import { Guid } from "guid-typescript";
import { SpondGroup } from "../models/Models";
import { SpondService } from '../services/SpondService';
import { inject } from 'vue';
import router from '../router';

export default class SpondGroups extends Vue {
  public groups: Array<SpondGroup> = [];
  public groupsLoaded = false;  
  private spondService: SpondService;

  async created() {
    this.spondService = inject('SpondService', new SpondService());
    
    this.spondService.getGroups()
      .then(async groups => {

        if (groups.length === 1) {
          await this.selectGroup(groups[0]);
          return;
        }

        this.groups = groups;
        this.groupsLoaded = true;
      })
      .catch(async err => {
        router.push({ name: "SpondLogin" });  
      });
  }

  async selectGroup(group: SpondGroup) {
    this.spondService.setSelectedGroup(group);

    router.push({ name: "SpondMatches" });    
  }

  async signout() {
    await this.spondService.signout();
    
    router.push({ name: "Matches" });  
  }
}
